export default "__VITE_ASSET__26dea10d__"